var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanorama(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.527,
    height: 34.656,
    viewBox: "0 0 30.527 34.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "virtual-tour",
    transform: "translate(0.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M-158,347.621a2.357,2.357,0,0,1,1.552-.517h1.035a1.034,1.034,0,0,1,1.035,1.035v1.552a1.034,1.034,0,0,1-1.035,1.035h-1.552A1.038,1.038,0,0,1-158,349.69v-4.656A1.034,1.034,0,0,1-156.965,344h1.552a1.034,1.034,0,0,1,1.035,1.035v1.035",
    transform: "translate(169.938 -316.569)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 3.621,
    height: 6.725,
    rx: 1.811,
    transform: "translate(17.112 27.431)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 2.587,
    transform: "translate(7.8 30.535)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M-168,349.173v.517a1.034,1.034,0,0,0,1.035,1.035h1.552a1.034,1.034,0,0,0,1.035-1.035v-4.656A1.034,1.034,0,0,0-165.413,344h-1.552A1.034,1.034,0,0,0-168,345.035v.517",
    transform: "translate(174.765 -316.569)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 1.811,
    cy: 1.811,
    r: 1.811,
    transform: "translate(22.802 25.879)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M-175.886,314.675c-3.528,1.189-5.192,3.015-5.192,5.063,0,3.582,6.218,6.485,14.74,6.485h3.406",
    transform: "translate(181.078 -302.414)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M-138.228,313.922c4.255,1.155,6.43,3.165,6.43,5.453,0,2.618-3.046,4.873-8.358,5.9",
    transform: "translate(161.326 -302.051)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M-150,333l2.069,2.069L-150,337.138",
    transform: "translate(166.077 -311.259)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(10.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M-803.182,122.962a3.079,3.079,0,0,1-3.116,3.125,3.1,3.1,0,0,1-3.108-3.126,3.176,3.176,0,0,1,3.174-3.115A3.1,3.1,0,0,1-803.182,122.962Z",
    transform: "translate(810.874 -119.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M-829.711,230.514a.807.807,0,0,1,.221.487c.031.43.01.864.007,1.589a9.023,9.023,0,0,0,3.522.711,9.025,9.025,0,0,0,3.376-.651c.044-.875.028-1.311.053-1.745a.625.625,0,0,1,.2-.394,2.446,2.446,0,0,0,.912-1.886c.016-2.006.025-4.012,0-6.018a2.5,2.5,0,0,0-2.5-2.448c-1.394-.015-2.788-.022-4.182.01a2.662,2.662,0,0,0-1.074.278,2.478,2.478,0,0,0-1.4,2.432c0,.668,0,1.335,0,2.01l-.042,1.421c0,.737,0,1.438,0,2.139A2.754,2.754,0,0,0-829.711,230.514Z",
    transform: "translate(830.624 -213.205)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanorama);
export default __webpack_public_path__ + "static/media/panorama.ca24c9fd1a235635fdb21b324a3f754c.svg";
export { ForwardRef as ReactComponent };